import { render, staticRenderFns } from "./AlarmDetails.vue?vue&type=template&id=138192fa"
import script from "./AlarmDetails.vue?vue&type=script&lang=js"
export * from "./AlarmDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports